import { useEffect, useState } from 'react'
import { flushSync } from 'react-dom'
import { stampText, usePrintPeriodText } from '@/lib/printMeta'

/**
 * The first line of a printout (WP-25), invisible on screen: «Сформировано 08.10.2026, 19:20,
 * период 01.09.2026 — 30.09.2026». The moment is taken when printing starts (`beforeprint`,
 * rendered synchronously so the paper has it), the period from the page's `DateRange`; a page
 * without dates says only when.
 */
export function PrintStamp({
  at: fixedAt,
  screen = false,
}: {
  /** a fixed moment (stories, tests) instead of «when printing starts» */
  at?: Date
  /** stories: visible on screen too */
  screen?: boolean
} = {}) {
  const period = usePrintPeriodText()
  const [at, setAt] = useState(() => fixedAt ?? new Date())
  useEffect(() => {
    if (fixedAt) return
    const onPrint = () => flushSync(() => setAt(new Date()))
    window.addEventListener('beforeprint', onPrint)
    return () => window.removeEventListener('beforeprint', onPrint)
  }, [fixedAt])
  return <p className={screen ? 'mb-4 text-caption text-ink-2' : 'mb-4 hidden text-caption text-ink-2 print:block'}>{stampText(at, period)}</p>
}
